import React, { createContext, useReducer, useState, useContext } from "react";

const CreateContext = createContext();

const CreateProvider = (props) => {
    const [bootCamp, setBootCamp] = useState();
    const [phaseStatus, setPhaseStatus] = useState({
        general: false,
        session: false,
        ticket: false,
        discount: false,
        role: false,
        personnel: false,
        faq: false,
        calculate: false,
        bill: false,
    });

    return (
        <CreateContext.Provider
            value={{ bootCamp, setBootCamp, phaseStatus, setPhaseStatus }}
            {...props}
        >
            {props.children}
        </CreateContext.Provider>
    );
};

const useCreate = () => useContext(CreateContext);

export { CreateProvider, useCreate };
